export interface ViewNote {
  readonly enable: boolean;
  readonly tagOnlyOne: boolean;
  readonly text: string;
}

export const defaultEmptyViewNote: ViewNote = {
  enable: false,
  tagOnlyOne: false,
  text: "",
};
